// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Reset ===== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  text-size-adjust: 100%;
}

/* ===== Base Typography ===== */
body {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Arial, sans-serif;

  font-size: 16px;
  line-height: 1.6;
  color: #1f1f1f;
  background-color: #efefef;
}

/* Make text naturally readable on mobile */
p {
  font-size: 1rem;
  line-height: 1.75;
  margin-bottom: 1rem;
}

/* Headings */
h1, h2, h3, h4 {
  line-height: 1.2;
  font-weight: 600;
}

/* Links */
a {
  color: #2563eb;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Optional: nice centered app wrapper */
#root {
  min-height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE;6BAC2B;;EAE3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;AACnB","sourcesContent":["/* ===== Reset ===== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n/* ===== Base Typography ===== */\nbody {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, Arial, sans-serif;\n\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1f1f1f;\n  background-color: #efefef;\n}\n\n/* Make text naturally readable on mobile */\np {\n  font-size: 1rem;\n  line-height: 1.75;\n  margin-bottom: 1rem;\n}\n\n/* Headings */\nh1, h2, h3, h4 {\n  line-height: 1.2;\n  font-weight: 600;\n}\n\n/* Links */\na {\n  color: #2563eb;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n/* Optional: nice centered app wrapper */\n#root {\n  min-height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
